import {useId, useMemo} from 'react'

/**
 * Generates a stable, SSR-safe, CSS-valid className.
 * Useful for dynamic styled-jsx selectors or Framer Motion components.
 */
export const useUniqueClassName = (prefix: string) => {
  const rawId = useId()

  // Remove invalid characters for CSS class names (like ":" or parentheses)
  const safeId = useMemo(() => rawId.replace(/[^a-zA-Z0-9-_]/g, ''), [rawId])

  return `${prefix}-${safeId}`
}
